import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Workflow } from './components/Workflow';
import { Deliverables } from './components/Deliverables';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-navy-950 font-sans text-white" data-id="element-0" data-mp="23vuq4hqc94x9">
      <MetaPixel data-id="element-1" data-mp="3ijxoypkvdyjd" />
      <main data-id="element-2" data-mp="3ikh9me1wn113">
        <Hero data-id="element-3" data-mp="3iiweam7rne26" />
        <BeforeAfter data-id="element-4" data-mp="3ij61k21ff746" />
        <PainPoints data-id="element-5" data-mp="3ihv2ugmu8pjx" />
        <Volumes data-id="element-6" data-mp="3mlj98vzqhf3l" />
        <Workflow data-id="element-7" data-mp="3ml12h5fg3ihf" />
        <Deliverables data-id="element-8" data-mp="3mkhnnxl3da7m" />
        <Bonuses data-id="element-9" data-mp="3mjq27fl7ksv2" />
        <Offer data-id="element-10" data-mp="3mj6hjr46bqdc" />
        <Guarantee data-id="element-11" data-mp="3rcj6618urx63" />
        <Testimonials data-id="element-12" data-mp="3rbzmaezn6ypf" />
        <About data-id="element-13" data-mp="3rdkgu4lyihna" />
        <FAQ data-id="element-14" data-mp="3rd19fhtxnbni" />
        <FinalCTA data-id="element-15" data-mp="3reltgdimfc74" />
      </main>
      <Footer data-id="element-16" data-mp="6hp9c27i9cj" />
      <FloatingCTA data-id="element-17" data-mp="4wvhonpuufq" />
      <PurchasePopup data-id="element-18" data-mp="5gfdawxfswe" />
    </div>;
}